<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<div class="container">
  <!--<p style="color:red">
    <strong>WARNING: application being tested in beta! Please, report bugs at <a href="mailto:vospace.ia2@inaf.it">vospace.ia2@inaf.it</a></strong>
  </p>-->
  <p>
    <strong>Please, report bugs at <a href="mailto:vospace.ia2@inaf.it">vospace.ia2@inaf.it</a></strong>
  </p>
  <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
  <div class="mb-3">
    <b-button variant="success" class="mr-2" :disabled="!writable" v-b-modal.create-folder-modal>New folder</b-button>
    <b-button variant="success" class="mr-2" :disabled="!writable" v-b-modal.upload-files-modal>Upload files</b-button>
    <b-button variant="success" class="mr-2" :disabled="!writable" v-b-modal.create-links-modal>Create links</b-button>
    <b-dropdown variant="primary" text="Actions" v-if="actionsEnabled">
      <b-dropdown-item :disabled="!asyncButtonEnabled" @click="startAsyncRecallJob">Async recall</b-dropdown-item>
      <b-dropdown-item :disabled="!deleteButtonEnabled" @click="deleteNodes">Delete</b-dropdown-item>
      <b-dropdown-item :disabled="!moveButtonEnabled" @click="moveNodes">Move</b-dropdown-item>
      <b-dropdown-item :disabled="!copyButtonEnabled" @click="copyNodes">Copy</b-dropdown-item>
      <b-dropdown-item :disabled="!archiveButtonEnabled" @click="createArchive('zip')">Create zip archive</b-dropdown-item>
      <b-dropdown-item :disabled="!archiveButtonEnabled" @click="createArchive('tar')">Create tar archive</b-dropdown-item>
    </b-dropdown>
  </div>
  <b-card>
    <table class="table b-table table-striped table-hover">
      <thead>
        <tr>
          <th id="checkboxes">
            <a href="#" @click.stop.prevent="selectAll">
              <BIconCheckSquare />
            </a>
            &nbsp;
            <a href="#" @click.stop.prevent="deSelectAll">
              <BIconSquare />
            </a>
          </th>
          <th>Name</th>
          <th>Size</th>
          <th>Group read</th>
          <th>Group write</th>
          <th></th>
        </tr>
      </thead>
      <tbody id="nodes"></tbody>
    </table>
  </b-card>
  <CreateFolderModal />
  <UploadFilesModal />
  <ConfirmDeleteModal />
  <ShareModal />
  <RenameModal />
  <MoveOrCopyModal />
  <ConfirmArchiveModal />
  <CreateLinksModal />
  <FAQModal />
</div>
</template>

<script>
import { BIconCheckSquare, BIconSquare } from 'bootstrap-vue'
import CreateFolderModal from './modal/CreateFolderModal.vue'
import UploadFilesModal from './modal/UploadFilesModal.vue'
import ConfirmDeleteModal from './modal/ConfirmDeleteModal.vue'
import ShareModal from './modal/ShareModal.vue'
import RenameModal from './modal/RenameModal.vue'
import MoveOrCopyModal from './modal/MoveOrCopyModal.vue'
import ConfirmArchiveModal from './modal/ConfirmArchiveModal.vue'
import CreateLinksModal from './modal/CreateLinksModal.vue'
import FAQModal from './modal/FAQModal.vue'

export default {
  components: {
    BIconCheckSquare,
    BIconSquare,
    CreateFolderModal,
    UploadFilesModal,
    ConfirmDeleteModal,
    ShareModal,
    RenameModal,
    MoveOrCopyModal,
    ConfirmArchiveModal,
    CreateLinksModal,
    FAQModal
  },
  computed: {
    breadcrumbs() {
      let items = [{
        text: 'ROOT',
        href: '#/nodes/'
      }];
      if (this.$store.state.path) {
        let pathSplit = this.$store.state.path.split('/');
        for (let i = 0; i < pathSplit.length; i++) {
          items.push({
            text: pathSplit[i],
            href: '#/nodes/' + pathSplit.slice(0, i + 1).map(p => encodeURIComponent(p)).join('/')
          });
        }
      }
      return items;
    },
    actionsEnabled() {
      return this.$store.state.user !== 'anonymous' &&
        (this.asyncButtonEnabled || this.deleteButtonEnabled || this.archiveButtonEnabled);
    },
    asyncButtonEnabled() {
      return this.$store.state.asyncButtonEnabled;
    },
    deleteButtonEnabled() {
      return this.$store.state.deleteButtonEnabled;
    },
    moveButtonEnabled() {
      return this.$store.state.moveButtonEnabled;
    },
    archiveButtonEnabled() {
      return this.$store.state.archiveButtonEnabled;
    },
    copyButtonEnabled() {
      return this.$store.state.copyButtonEnabled;
    },
    writable() {
      return this.$store.state.writable;
    }
  },
  created() {
    this.loadNode();
  },
  watch: {
    '$route.params.path': 'loadNode'
  },
  methods: {
    loadNode() {
      this.$store.dispatch('setPath', this.$route.params.path);
    },
    selectAll() {
      this.selectInputs(true);
    },
    deSelectAll() {
      this.selectInputs(false);
    },
    selectInputs(value) {
      document.querySelectorAll('#nodes input').forEach(input => {
        input.checked = value;
        this.$store.dispatch('computeButtonsVisibility');
      });
    },
    startAsyncRecallJob() {
      this.$store.dispatch('startAsyncRecallJob');
    },
    deleteNodes() {
      let selectedNodesCheckboxes = document.querySelectorAll('#nodes input:checked');
      let paths = [];
      let unDeletablePaths = [];
      for (let i = 0; i < selectedNodesCheckboxes.length; i++) {
        let checkbox = selectedNodesCheckboxes[i];
        let dataNode = checkbox.getAttribute('data-node');
        if (checkbox.classList.contains('deletable')) {
          paths.push(dataNode);
        } else {
          unDeletablePaths.push(dataNode);
        }
      }
      this.$store.commit('setNodesToDelete', paths);
      this.$store.commit('setSelectedUndeletableNodes', unDeletablePaths);
      this.$bvModal.show('confirm-delete-modal');
    },
    moveNodes() {
      let selectedNodesCheckboxes = document.querySelectorAll('#nodes input:checked');
      let paths = [];
      let unDeletablePaths = [];
      for (let i = 0; i < selectedNodesCheckboxes.length; i++) {
        let checkbox = selectedNodesCheckboxes[i];
        let dataNode = checkbox.getAttribute('data-node');
        if (checkbox.classList.contains('deletable')) {
          paths.push(dataNode);
        } else {
          unDeletablePaths.push(dataNode);
        }
      }
      this.$store.commit('setNodesToMoveOrCopy', paths);
      this.$store.commit('setMoveOrCopy', 'move');
      this.$store.commit('setSelectedNotMovableNodes', unDeletablePaths);
      this.$bvModal.show('move-or-copy-modal');
    },
    copyNodes() {
      let selectedNodesCheckboxes = document.querySelectorAll('#nodes input:checked');
      let paths = [];
      let unCopiablePaths = [];
      for (let i = 0; i < selectedNodesCheckboxes.length; i++) {
        let checkbox = selectedNodesCheckboxes[i];
        let dataNode = checkbox.getAttribute('data-node');
        if (checkbox.classList.contains('async')) {
          unCopiablePaths.push(dataNode);
        } else {
          paths.push(dataNode);
        }
      }
      this.$store.commit('setNodesToMoveOrCopy', paths);
      this.$store.commit('setMoveOrCopy', 'copy');
      this.$store.commit('setSelectedNotCopiableNodes', unCopiablePaths);
      this.$bvModal.show('move-or-copy-modal');
    },
    createArchive(type) {
      let selectedNodesCheckboxes = document.querySelectorAll('#nodes input:checked');
      let nodesToArchive = [];
      let notArchivableNodes = [];
      for (let i = 0; i < selectedNodesCheckboxes.length; i++) {
        let checkbox = selectedNodesCheckboxes[i];
        let dataNode = checkbox.getAttribute('data-node');
        if (checkbox.classList.contains('async')) {
          notArchivableNodes.push(dataNode);
        } else {
          nodesToArchive.push(dataNode);
        }
      }
      this.$store.commit('setArchiveType', type);
      this.$store.commit('setNodesToArchives', nodesToArchive);
      if (notArchivableNodes.length === 0) {
        this.$store.dispatch('createArchive', type)
      } else {
        this.$store.commit('setSelectedNotArchivableNodes', notArchivableNodes);
        this.$bvModal.show('confirm-archive-modal');
      }
    }
  }
}
</script>

<style>
@import '../assets/css/fonts.css';

.table {
  text-align: left;
}

#nodes>tr>td:nth-child(2) {
  white-space: nowrap;
}

th#checkboxes {
  /* Credits: https://stackoverflow.com/a/43615091/771431 */
  width: 0.1%;
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
}
</style>
